// import { useState } from "react";
// import axios from "axios";

// export default function Register() {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     parentPhone: "",
//     qualification: "",
//     graduationYear: "",
//     currentActivity: "", // ✅ new field
//   });
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);

//   // Use REACT_APP_API_URL if available (for production)
//   const API_BASE =
//   (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/$/, "");

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const validate = () => {
//     if (!form.name.trim()) return "Please enter full name.";
//     if (!form.email.trim()) return "Please enter email.";
//     if (!/^\S+@\S+\.\S+$/.test(form.email)) return "Please enter a valid email.";

//     const cleanPhone = (form.phone || "").replace(/\D/g, "");
//     const cleanParent = (form.parentPhone || "").replace(/\D/g, "");
//     if (!/^\d{10}$/.test(cleanPhone))
//       return "Please enter a valid 10-digit student phone.";
//     if (!/^\d{10}$/.test(cleanParent))
//       return "Please enter a valid 10-digit parent phone.";
//     if (cleanPhone === cleanParent)
//       return "Student and Parent phone numbers cannot be the same.";

//     if (!form.qualification)
//       return "Please select qualification.";

//     // ✅ New validation for “Other / Diploma”
//     if (form.qualification === "Other" && !form.currentActivity.trim())
//       return "Please specify what you are currently doing.";

//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMessage("");

//     const errMsg = validate();
//     if (errMsg) {
//       setMessage("⚠️ " + errMsg);
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = {
//         name: form.name.trim(),
//         email: form.email.trim().toLowerCase(),
//         phone: form.phone.replace(/\D/g, ""),
//         parent_phone: form.parentPhone.replace(/\D/g, ""),
//         qualification: form.qualification,
//         graduationYear: form.graduationYear
//           ? Number(form.graduationYear)
//           : null,
//         current_activity:
//           form.qualification === "Other"
//             ? form.currentActivity.trim()
//             : null,
//       };

//       // const url = (API_BASE || "") + "/api/students/register";

//       const url = `${API_BASE}/api/students/register`;
//       const res = await axios.post(url, payload, { timeout: 30000 });

//       setMessage(
//         res.data?.message ||
//           "✅ Registration successful. Check your email to set your password."
//       );
//       setForm({
//         name: "",
//         email: "",
//         phone: "",
//         parentPhone: "",
//         qualification: "",
//         graduationYear: "",
//         currentActivity: "",
//       });
//     } catch (err) {
//       console.error("registration error:", err);

//       let friendly = "Registration failed";
//       if (err.message && err.message.includes("Network Error")) {
//         friendly =
//           "Network error. Is the backend running? Try starting your backend (node src/server.js).";
//       } else if (err.code === "ECONNABORTED") {
//         friendly = "Request timed out. Please try again.";
//       } else if (
//         err.message &&
//         err.message.includes("connect ECONNREFUSED")
//       ) {
//         friendly =
//           "Could not reach backend (ECONNREFUSED). Is your backend running on port 5000?";
//       } else if (err.response) {
//         const status = err.response.status;
//         const data = err.response.data;
//         if (status === 500) {
//           friendly =
//             data?.message ||
//             data?.error ||
//             "Server error (500). Check backend logs for details.";
//         } else if (status === 400) {
//           friendly = data?.message || "Bad request (400). Check the form values.";
//         } else if (status === 401) {
//           friendly = data?.message || "Unauthorized (401).";
//         } else {
//           friendly = data?.message || `Server responded with status ${status}.`;
//         }
//       } else {
//         friendly = err.message || friendly;
//       }

//       setMessage("❌ " + friendly);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container my-5">
//       <div className="card shadow p-4 mx-auto" style={{ maxWidth: "640px" }}>
//         <h2 className="mb-4 fw-bold text-center">Student Registration</h2>

//         <form onSubmit={handleSubmit} noValidate>
//           <div className="mb-3">
//             <label className="form-label">Full Name</label>
//             <input
//               className="form-control"
//               name="name"
//               value={form.name}
//               onChange={handleChange}
//               placeholder="e.g. Rahul Sharma"
//               required
//             />
//           </div>

//           <div className="row">
//             <div className="mb-3 col-md-6">
//               <label className="form-label">Email</label>
//               <input
//                 className="form-control"
//                 name="email"
//                 type="email"
//                 value={form.email}
//                 onChange={handleChange}
//                 placeholder="you@example.com"
//                 required
//               />
//             </div>

//             <div className="mb-3 col-md-6">
//               <label className="form-label">Student Phone</label>
//               <input
//                 className="form-control"
//                 name="phone"
//                 value={form.phone}
//                 onChange={handleChange}
//                 placeholder="10-digit phone"
//                 required
//               />
//             </div>

//             <div className="mb-3 col-md-6">
//               <label className="form-label">Parent Phone</label>
//               <input
//                 className="form-control"
//                 name="parentPhone"
//                 value={form.parentPhone}
//                 onChange={handleChange}
//                 placeholder="Parent's 10-digit phone"
//                 required
//               />
//             </div>
//           </div>

//           <div className="mb-3">
//             <label className="form-label">Qualification</label>
//             <select
//               name="qualification"
//               className="form-select"
//               value={form.qualification}
//               onChange={handleChange}
//               required
//             >
//               <option value="">-- Select --</option>
//               <option value="B.Com">B.Com (Graduate)</option>
//               <option value="Class 12 (Commerce)">
//                 Class 12 (Commerce)
//               </option>
//               <option value="Other">Other / Diploma</option>
//             </select>
//             <div className="form-text">
//               Class 12 (Commerce) students are welcome — choose that option if
//               you are in/just finished 12th.
//             </div>
//           </div>

//           {/* ✅ Show "What are you currently doing?" when qualification === 'Other' */}
//           {form.qualification === "Other" && (
//             <div className="mb-3">
//               <label className="form-label">
//                 What are you currently doing?
//               </label>
//               <input
//                 className="form-control"
//                 name="currentActivity"
//                 value={form.currentActivity}
//                 onChange={handleChange}
//                 placeholder="e.g. BBA, BSC , etc"
//                 required
//               />
//             </div>
//           )}

//           <div className="mb-3">
//             <label className="form-label">Graduation Year (if applicable)</label>
//             <input
//               className="form-control"
//               name="graduationYear"
//               type="number"
//               value={form.graduationYear}
//               onChange={handleChange}
//               min="2010"
//               max={new Date().getFullYear() + 1}
//             />
//           </div>

//           <button
//             type="submit"
//             className="btn btn-gold w-100 fw-bold"
//             disabled={loading}
//           >
//             {loading ? "Submitting..." : "Submit"}
//           </button>
//         </form>

//         {message && (
//           <div
//             className={`alert mt-3 ${
//               message.startsWith("✅")
//                 ? "alert-success"
//                 : message.startsWith("⚠️")
//                 ? "alert-warning"
//                 : "alert-info"
//             }`}
//             role="alert"
//           >
//             {message}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }


import { useState } from "react";
import api from "../utils/api"; // ✅ CHANGED

export default function Register() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    parentPhone: "",
    qualification: "",
    graduationYear: "",
    currentActivity: "",
  });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    if (!form.name.trim()) return "Please enter full name.";
    if (!form.email.trim()) return "Please enter email.";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) return "Please enter a valid email.";

    const cleanPhone = (form.phone || "").replace(/\D/g, "");
    const cleanParent = (form.parentPhone || "").replace(/\D/g, "");

    if (!/^\d{10}$/.test(cleanPhone))
      return "Please enter a valid 10-digit student phone.";

    if (!/^\d{10}$/.test(cleanParent))
      return "Please enter a valid 10-digit parent phone.";

    if (cleanPhone === cleanParent)
      return "Student and Parent phone numbers cannot be the same.";

    if (!form.qualification)
      return "Please select qualification.";

    if (form.qualification === "Other" && !form.currentActivity.trim())
      return "Please specify what you are currently doing.";

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const errMsg = validate();
    if (errMsg) {
      setMessage("⚠️ " + errMsg);
      return;
    }

    setLoading(true);

    try {
      const payload = {
        name: form.name.trim(),
        email: form.email.trim().toLowerCase(),
        phone: form.phone.replace(/\D/g, ""),
        parent_phone: form.parentPhone.replace(/\D/g, ""),
        qualification: form.qualification,
        graduationYear: form.graduationYear
          ? Number(form.graduationYear)
          : null,
        current_activity:
          form.qualification === "Other"
            ? form.currentActivity.trim()
            : null,
      };

      // ✅ CHANGED ONLY THIS LINE
      const res = await api.post("/api/students/register", payload);

      setMessage(
        res.data?.message ||
          "✅ Registration successful. Check your email to set your password."
      );

      setForm({
        name: "",
        email: "",
        phone: "",
        parentPhone: "",
        qualification: "",
        graduationYear: "",
        currentActivity: "",
      });

    } catch (err) {
      console.error("registration error:", err);

      let friendly = "Registration failed";

      if (err.message && err.message.includes("Network Error")) {
        friendly =
          "Network error. Is the backend running? Try starting your backend (node src/server.js).";
      } else if (err.code === "ECONNABORTED") {
        friendly = "Request timed out. Please try again.";
      } else if (
        err.message &&
        err.message.includes("connect ECONNREFUSED")
      ) {
        friendly =
          "Could not reach backend (ECONNREFUSED). Is your backend running on port 5000?";
      } else if (err.response) {
        const status = err.response.status;
        const data = err.response.data;

        if (status === 500) {
          friendly =
            data?.message ||
            data?.error ||
            "Server error (500). Check backend logs for details.";
        } else if (status === 400) {
          friendly = data?.message || "Bad request (400). Check the form values.";
        } else if (status === 401) {
          friendly = data?.message || "Unauthorized (401).";
        } else {
          friendly = data?.message || `Server responded with status ${status}.`;
        }
      } else {
        friendly = err.message || friendly;
      }

      setMessage("❌ " + friendly);

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-5">
      <div className="card shadow p-4 mx-auto" style={{ maxWidth: "640px" }}>
        <h2 className="mb-4 fw-bold text-center">Student Registration</h2>

        <form onSubmit={handleSubmit} noValidate>

          <div className="mb-3">
            <label className="form-label">Full Name</label>
            <input
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="e.g. Rahul Sharma"
              required
            />
          </div>

          <div className="row">

            <div className="mb-3 col-md-6">
              <label className="form-label">Email</label>
              <input
                className="form-control"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
                required
              />
            </div>

            <div className="mb-3 col-md-6">
              <label className="form-label">Student Phone</label>
              <input
                className="form-control"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="10-digit phone"
                required
              />
            </div>

            <div className="mb-3 col-md-6">
              <label className="form-label">Parent Phone</label>
              <input
                className="form-control"
                name="parentPhone"
                value={form.parentPhone}
                onChange={handleChange}
                placeholder="Parent's 10-digit phone"
                required
              />
            </div>

          </div>

          <div className="mb-3">
            <label className="form-label">Qualification</label>
            <select
              name="qualification"
              className="form-select"
              value={form.qualification}
              onChange={handleChange}
              required
            >
              <option value="">-- Select --</option>
              <option value="B.Com">B.Com (Graduate)</option>
              <option value="Class 12 (Commerce)">
                Class 12 (Commerce)
              </option>
              <option value="Other">Other / Diploma</option>
            </select>

            <div className="form-text">
              Class 12 (Commerce) students are welcome — choose that option if
              you are in/just finished 12th.
            </div>
          </div>

          {form.qualification === "Other" && (
            <div className="mb-3">
              <label className="form-label">
                What are you currently doing?
              </label>
              <input
                className="form-control"
                name="currentActivity"
                value={form.currentActivity}
                onChange={handleChange}
                placeholder="e.g. BBA, BSC , etc"
                required
              />
            </div>
          )}

          <div className="mb-3">
            <label className="form-label">Graduation Year (if applicable)</label>
            <input
              className="form-control"
              name="graduationYear"
              type="number"
              value={form.graduationYear}
              onChange={handleChange}
              min="2010"
              max={new Date().getFullYear() + 1}
            />
          </div>

          <button
            type="submit"
            className="btn btn-gold w-100 fw-bold"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>

        </form>

        {message && (
          <div
            className={`alert mt-3 ${
              message.startsWith("✅")
                ? "alert-success"
                : message.startsWith("⚠️")
                ? "alert-warning"
                : "alert-info"
            }`}
            role="alert"
          >
            {message}
          </div>
        )}
      </div>
    </div>
  );
}